const local = process.env.REACT_APP_LOCAL_URL || "http://localhost:5001";

export const URL = local;
